import { authJson, postJson } from "../utils/httpService";
import { authenticationURLs } from "../data/constants";

async function login(data) {
  try {
    return await authJson(authenticationURLs.login, {
      email: data.email,
      password: data.password,
    });
  } catch (e) {
    throw e;
  }
}

async function logout(token) {
  try {
    return await postJson(
      authenticationURLs.logout,
      {
        token: token,
        status: "INVALID",
      },
      token
    );
  } catch (e) {
    throw e;
  }
}
export { login, logout };
